import React, {useState, useEffect, useCallback} from 'react';
import { useParams, useLocation, Link, useNavigate } from "react-router-dom";
import { Url } from '../global';

//COMPONENT
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import VideoViewer from "../page/VideoViewer";

//STYLE & ICON
import './VideoGallery.css';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import { ReactComponent as PlayWatermark } from "../assets/play.svg";
import { ReactComponent as PlayWatermarkActive } from "../assets/playActive.svg";


export const VideoGallery = (props)=>{
const [currentIndex, setCurrentIndex] = React.useState(0);
const [openVideo, setOpenVideo] = useState(false);
const [Id, setId] = useState(1);
const [videoHover, setVideoHover] = useState([]);
const [videoList, setVideoList] = useState([]);
const [videoContent, setVideoContent] = useState([]);

useEffect(async() => {
  // const requestOptions = {
  //   method: 'POST',
  //   headers: { 'Content-Type': 'application/json' },
  //   body: JSON.stringify({ 'articleId': articleId })
  // };

  const response = await fetch(Url + '/android/get_video.php');
  const json = await response.json();
  setVideoList( json );
  setVideoHover(()=> videoList.map(() => false));

},[])

useEffect(async() => {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ 'Id': Id })
  };
  const response = await fetch(Url + '/android/get_video_content.php', requestOptions);
  const json = await response.json();

  setVideoContent( json[0] );
},[Id])


const width = 520; //banner width
let position = 0;
position -= width * currentIndex;

let itemCount = videoList.length;

const VideoViewer_Open = (event)=>{
    setId(event.currentTarget.id);
    setOpenVideo(true);
}

const VideoViewer_Close = ()=>{
    setOpenVideo(false);
}

const handleOver = (event) => {
    //setVideoHover({'id' : event.target.id, 'status' : true });
  // event.target.style.background = 'var(--secondary)';
  // event.target.style.color = 'white';
  // setPatientData(prevData => ( {...prevData, "DOB" : event} )) 

  const newVisibilities = [...videoHover];
  newVisibilities[event.currentTarget.id] = true;
  setVideoHover(newVisibilities);

};

const handleOut = (event) => {
  const newVisibilities = [...videoHover]; // store hover state to temp variable
  newVisibilities[event.currentTarget.id] = false; // set target id status in temp variablee
  setVideoHover(newVisibilities); // set to videoHover state 
};

return(
        <div className="VideoGalleryContainer" >
        <VideoViewer Id= {Id} 
                      videoContent={videoContent}
                      open={openVideo}
                      handleInformation_Close={VideoViewer_Close} />

        {/* {      JSON.stringify(videoHover)} */}
        <h3>VIDEO KESEHATAN: </h3>

            <div className="ControlContainer">
                <div className="VideoGalleryBox">
                {   videoList.map((item, index)=>{
                    let video_tn = "https://img.youtube.com/vi/" + item.VideoId + "/maxresdefault.jpg";
                    // const path = "assets/article/" + props.photo;
                    // const image = require("../" + path);
                        return( 
                                <Card key={index}
                                      className="VideoCard"
                                      style ={{ left:(width * index) + position }}
                                      id ={item.Id}
                                      onMouseOver={handleOver}
                                      onMouseOut={handleOut}>
                                    
                                    <div className="MediaContainer">
                                        {videoHover[item.Id] ? <PlayWatermarkActive className="PlayWatermark" onClick={VideoViewer_Open}/> : <PlayWatermark className="PlayWatermark" onClick={VideoViewer_Open}/>}
                                        
                                        <CardMedia className= "VideoMedia"
                                                    component="img"
                                                    id={item.Id}
                                                    image= {video_tn}
                                                    onClick={VideoViewer_Open} />
                                    </div>

                                    <CardContent className="Content"
                                                  id={item.Id}
                                                  onClick={VideoViewer_Open}>

                                        <h3>{item.Header}</h3>
                                        <p className="VideoDatetime">{item.CreateDate} </p>
                                    </CardContent>
                                </Card>
                        );
                    })
                }

                </div>
              
            </div>

        </div>
        
    );

}


export default VideoGallery;

